import React from "react";
import _ from "lodash";
import Checkbox from "components/common/Checkbox";
import PriceUnit from "components/ops-mgmt/account/upr-segmentation/PriceUnit";
import { getGroupTypeColor } from "./AnatomyHighchartHelper";
import { getPriceType } from "components/ops-mgmt/account/upr-segmentation/UPRSegmentationHelper";

class SegmentStickyHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroupTypes: props.selectedGroupTypes,
    };

    this.handleGroupTypeSelected = this.handleGroupTypeSelected.bind(this);
  }

  handleGroupTypeSelected(groupType) {
    let { selectedGroupTypes } = this.state;
    let groupTypes = null;

    if (groupType === "ALL") {
      const isAllSelected =
        selectedGroupTypes.length === this.props.groupTypes.length;
      groupTypes = isAllSelected ? [] : this.props.groupTypes;
    } else if (groupType === "OBX") {
      groupTypes = ["o", "b", "x"];
    } else {
      if (_.indexOf(selectedGroupTypes, groupType) === -1) {
        groupTypes = [...selectedGroupTypes, groupType];
      } else {
        groupTypes = _.without(selectedGroupTypes, groupType);
      }
    }

    this.setState({
      selectedGroupTypes: groupTypes,
    });

    this.props.handleSelectedGroupTypes(groupTypes);
  }

  render() {
    const { isPaused, uprSegmentId, items, groupTypes, detectorFloorPriceMap } =
      this.props;
    const { selectedGroupTypes } = this.state;
    const segment = _.find(items, { upr_segment_id: uprSegmentId });
    const isAllSelected = selectedGroupTypes.length === groupTypes.length;

    return (
      <div
        id="anatomy-chart-head"
        className="shadow sticky top-0 z-50 mt-4 flex items-center justify-between bg-blue-100 px-4 py-2"
        style={{ top: isPaused ? "2.5rem" : "0" }}
      >
        <div className="text-lg font-bold">
          {uprSegmentId !== -1 && segment
            ? `${segment.upr_segment_id} ${segment.name}`
            : "Unsegmented"}
        </div>

        <div className="flex gap-4">
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="rounded border border-gray-400 bg-gray-100 px-2 text-xs text-gray-800 hover:border-gray-500 hover:text-gray-900"
              onClick={() => this.handleGroupTypeSelected("OBX")}
            >
              Only o, b, x
            </button>

            <button
              type="button"
              className="rounded border border-gray-400 bg-gray-100 px-2 text-xs text-gray-800 hover:border-gray-500 hover:text-gray-900"
              onClick={() => this.handleGroupTypeSelected("ALL")}
            >
              {isAllSelected ? "Clear" : "Select"} All
            </button>
          </div>

          {groupTypes.map((groupType) => {
            const floorPrice = detectorFloorPriceMap[groupType];
            const { type } = getPriceType(floorPrice);

            return (
              <div key={groupType} className="flex flex-col items-end">
                <label
                  className="flex cursor-pointer items-center gap-1 border-b-2"
                  style={{
                    borderColor: getGroupTypeColor(
                      groupType,
                      groupTypes.length > 10 ? 10 : 5 // should filter b, o to get numOfDetector
                    ),
                  }}
                >
                  <Checkbox
                    isChecked={_.indexOf(selectedGroupTypes, groupType) !== -1}
                    onChange={() => this.handleGroupTypeSelected(groupType)}
                  ></Checkbox>
                  <span className="align-middle text-sm font-semibold text-gray-700 hover:text-gray-800">
                    {groupType}
                  </span>
                </label>

                {!_.isNil(floorPrice) && (
                  <span className="mt-1 text-sm leading-none text-gray-800">
                    <small className="flex items-center gap-1">
                      <PriceUnit
                        price={floorPrice}
                        readOnly={true}
                        isTextOnly={true}
                      ></PriceUnit>
                    </small>
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default SegmentStickyHeader;
